import { useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import type { ThinkingMode } from "../../api/types.js";
import { useComposerMenu } from "./useComposerMenu.js";

const MODE_LABEL: Record<ThinkingMode, string> = {
  thinking: "DeepSeek Thinking",
  fast: "DeepSeek 快速"
};

// 思考模式收成单个下拉药丸(与检索药丸对称),默认显示当前模式,点开切换。
// 用 click 展开(思考模式在移动端也显示,不能只靠 hover)。
export function ThinkingModeSelector({
  thinkingMode,
  setThinkingMode
}: {
  thinkingMode: ThinkingMode;
  setThinkingMode: (mode: ThinkingMode) => void;
}) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const menu = useComposerMenu({ open, setOpen, triggerRef, menuRef });
  const select = (mode: ThinkingMode) => {
    setThinkingMode(mode);
    menu.closeMenu();
  };
  return (
    <div className="thinking-mode-selector" role="group" aria-label="DeepSeek 模式">
      <button
        ref={triggerRef}
        type="button"
        className="model-select-button"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-controls="thinking-mode-menu"
        onClick={() => open ? menu.closeMenu() : menu.openMenu()}
        onKeyDown={menu.onTriggerKeyDown}
      >
        <span>{MODE_LABEL[thinkingMode]}</span>
        <ChevronDown size={14} />
      </button>
      {open && (
        <div
          ref={menuRef}
          id="thinking-mode-menu"
          className="model-menu"
          role="listbox"
          aria-label="DeepSeek 模式"
          onKeyDown={menu.onMenuKeyDown}
        >
          <button
            type="button"
            role="option"
            aria-selected={thinkingMode === "thinking"}
            onClick={() => select("thinking")}
          >
            DeepSeek Thinking
          </button>
          <button
            type="button"
            role="option"
            aria-selected={thinkingMode === "fast"}
            onClick={() => select("fast")}
          >
            DeepSeek 快速
          </button>
        </div>
      )}
    </div>
  );
}
